module.exports = __webpack_public_path__ + "img/handyman-no-bg.aefc1ca7.png";